import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { range } from 'lodash';
import { List } from 'immutable';

import Form from '../Form';

import SportCompetitionsInput from '../SportCompetitionsInput';

import { ChannelsCheckboxesWrapper, ChannelWrapper, ChannelCheckbox } from './BetTickerForm.style.tsx';

class BetTickerForm extends Form {
    static propTypes = {
        ...Form.propTypes,
        sports: ImmutablePropTypes.list,
    };

    static defaultProps = {
        ...Form.defaultProps,
        sports: List(),
    };

    static fieldsValidation = {
        betsAbove: ['decimal'],
        stakeFactor: ['decimal'],
        'highlight.betsAbove': ['decimal'],
        'highlight.stakeFactor': ['decimal'],
    };

    onSubmit(e) {
        e.preventDefault();

        Form.prototype.onSubmit.call(this, e);
    }

    renderForm() {
        const { sports } = this.props;

        const leftColumn = (
            <div className='col-7'>
                <h3>Choose filters</h3>
                <div className='row'>
                    <div className='col-12'>
                        {this.getField(
                            <input type='text' label='Bets above (£)' {...this.getFieldParameters('betsAbove')} />
                        )}
                    </div>

                    <div className='col-3'>
                        {this.getField(
                            <select {...this.getFieldParameters('stakeFactorCondition')}>
                                <option value='<'>&lt;</option>
                                <option value='>'>&gt;</option>
                                <option value='='>=</option>
                                <option value='<='>&lt;=</option>
                                <option value='>='>&gt;=</option>
                            </select>
                        )}
                    </div>
                    <div className='col-9'>
                        {this.getField(
                            <input type='text' label='Stake factor' {...this.getFieldParameters('stakeFactor')} />
                        )}
                    </div>
                </div>
                <div className='row'>
                    <div className='col-9'>
                        {this.getField(
                            <SportCompetitionsInput sports={sports} {...this.getFieldParameters('sport')} />
                        )}
                    </div>
                    <div className='col-3'>{this.getCheckbox('rejectedBets', 'Rejected bets')}</div>
                </div>
            </div>
        );

        const rightColumn = (
            <div className='col-5'>
                <h3>Special highlights</h3>

                <div className='row'>
                    <div className='col-11'>
                        {this.getField(
                            <input
                                type='text'
                                label='Bets above (£)'
                                {...this.getFieldParameters('highlight.betsAbove')}
                            />
                        )}
                    </div>
                    <div className='col-1'>
                        {this.getField(<input type='color' {...this.getFieldParameters('highlight.betsAboveColor')} />)}
                    </div>
                </div>

                <div className='row'>
                    <div className='col-3'>
                        {this.getField(
                            <select {...this.getFieldParameters('highlight.stakeFactorCondition')}>
                                <option value='<'>&lt;</option>
                                <option value='>'>&gt;</option>
                                <option value='='>=</option>
                                <option value='<='>&lt;=</option>
                                <option value='>='>&gt;=</option>
                            </select>
                        )}
                    </div>
                    <div className='col-8'>
                        {this.getField(
                            <input
                                type='text'
                                label='Stake factor'
                                {...this.getFieldParameters('highlight.stakeFactor')}
                            />
                        )}
                    </div>
                    <div className='col-1'>
                        {this.getField(
                            <input type='color' {...this.getFieldParameters('highlight.stakeFactorColor')} />
                        )}
                    </div>
                </div>
                <ChannelsCheckboxesWrapper>
                    <ChannelWrapper>
                        <ChannelCheckbox>
                            {this.getCheckbox('channelDesktop', 'Desktop only bets', {
                                ...this.getFieldParameters('highlight.channelDesktop'),
                            })}
                        </ChannelCheckbox>
                        {this.getField(
                            <input type='color' {...this.getFieldParameters('highlight.channelDesktopColor')} />
                        )}
                    </ChannelWrapper>
                    <ChannelWrapper>
                        <ChannelCheckbox>
                            {this.getCheckbox('channelMobile', 'Mobile only bets', {
                                ...this.getFieldParameters('highlight.channelMobile'),
                            })}
                        </ChannelCheckbox>
                        {this.getField(
                            <input type='color' {...this.getFieldParameters('highlight.channelMobileColor')} />
                        )}
                    </ChannelWrapper>
                    <ChannelWrapper>
                        <ChannelCheckbox>
                            {this.getCheckbox('channelQuickbet', 'Quickbet only bets', {
                                ...this.getFieldParameters('highlight.channelQuickbet'),
                            })}
                        </ChannelCheckbox>
                        {this.getField(
                            <input type='color' {...this.getFieldParameters('highlight.channelQuickbetColor')} />
                        )}
                    </ChannelWrapper>
                    <ChannelWrapper>
                        <ChannelCheckbox>
                            {this.getCheckbox('channelTelebetting', 'Telebetting only bets', {
                                ...this.getFieldParameters('highlight.channelTelebetting'),
                            })}
                        </ChannelCheckbox>
                        {this.getField(
                            <input type='color' {...this.getFieldParameters('highlight.channelTelebettingColor')} />
                        )}
                    </ChannelWrapper>
                </ChannelsCheckboxesWrapper>

                <div className='row'>
                    <div className='col-11'>
                        {this.getField(
                            <input
                                type='text'
                                label='% Max Stake above'
                                {...this.getFieldParameters('highlight.maxStakePercentage')}
                            />
                        )}
                    </div>
                    <div className='col-1'>
                        {this.getField(
                            <input type='color' {...this.getFieldParameters('highlight.maxStakePercentageColor')} />
                        )}
                    </div>
                </div>

                <div className='buttons'>
                    <button className='btn btn-primary' type='submit'>
                        Start ticker
                    </button>
                </div>
            </div>
        );

        return (
            <div className='bet-ticker-form'>
                <div className='row'>
                    {leftColumn}
                    {rightColumn}
                </div>
            </div>
        );
    }
}

export default BetTickerForm;
